// extracted by mini-css-extract-plugin
export default {"title":"subcategory_title__u8Ja1","titleIcon":"subcategory_titleIcon__OcGo9"};